import { Component, ElementRef, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';
import moment from 'moment';
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { AddItemDialogComponent } from '../add-item-dialog/add-item-dialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { SupplyBuildingDialogComponent } from '../supply-building-dialog/supply-building-dialog.component';
import { Router } from '@angular/router';
import { ScenarioBasedMenuItemPayload } from '../menu-dialog/menu-dialog.component';
import { MessSummaryDialogComponent } from '../mess-summary-dialog/mess-summary-dialog.component';
import { DoMenuComponent } from '../do-menu/do-menu.component';
import { DaysheetcloseConfirmationMessageDialogComponent } from '../daysheetclose-confirmation-message-dialog/daysheetclose-confirmation-message-dialog.component';
import { ConfirmationMessageDialogComponent } from '../confirmation-message-dialog/confirmation-message-dialog.component';

const MEAL_QTY_FIELDS = ['bfQty', 'lunchQty', 'snacksQty', 'DinnerQty'] as const;
type MealQtyField = (typeof MEAL_QTY_FIELDS)[number];

export interface PeriodicElement2 {
  itemName: string;
  teluguItemName: string;
  itemFusionId: string;
  openBalance: any;
  totalQty: any;
  bfQty: any;
  lunchQty: any;
  snacksQty: any;
  DinnerQty: any;
  ratePerUnit: any;
  totalAmount: any;
  closedBalance: any;
  itemId: any;
  itemStatus?: string;
}

@Component({
  selector: 'app-mess-do-detail-view',
  templateUrl: './mess-do-detail-view.component.html',
  styleUrls: ['./mess-do-detail-view.component.scss']
})
export class MessDoDetailViewComponent implements OnInit {
  messBuildingId: any;
  daysheetDate: any;
  messBuildingName: any;
  holidayReason: any;
  holiday: any;
  supplyBuildingTableExpanded = true;
  status: any;

  // ✅ fires when tab/browser closes or refreshes
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = ''; // ✅ required for Chrome
    return 'Are you sure you want to leave? Changes may not be saved.';
  }

  current = new Date();
  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  campusQuery: string = '';
  KitchenType: any = '';
  selectDate: string = '';
  messDate: any;
  allocatedCampusList: any;
  filteredCampusDetails: any;
  selectedBuildingName: any;
  selectedBuildingID: any;
  buildingValue: any;
  quickFilter: string = '';
  MealsType: string = '';
  userbuildingId: any;
  /** Item Name column: English vs Telugu label (data still has both fields). */
  itemNameDisplayLang: 'en' | 'te' = 'en';
  inventroyData: any;
  /** Daysheet date key last applied from `getInventoryDetails` merge (avoids stale status). */
  private lastInventoryDetailsDate = '';
  gridApi!: GridApi;

  // ✅ Store total amount
  totalAmountValue: number = 0;

  /** When daysheet is closed, Submit Daysheet must stay disabled. */
  isDaysheetSubmitDisabled = false;

  daysheetStatus: string = '';
  private daysheetStatusByDate = new Map<string, string>();

  /** Used by Angular Material datepicker to color dates based on status. */
  daysheetDateClass = (date: Date): string => {
    const key = moment(date).format('DD MMM YYYY');
    const status = String(this.daysheetStatusByDate.get(key) ?? '').trim();
    if (status === 'PENDING') return 'daysheet-pending';
    if (status === 'CLOSED') return 'daysheet-close';
    return '';
  };

  // supplyBuilding//
  BuildingDetails: any[] = [];
  currentDate: any;
  scenarioBasedMenuItemsList: ScenarioBasedMenuItemPayload[] = [];
  /** Daysheet date for which Supply Building summary dialog was submitted this session. */
  private supplyBuildingSubmittedForDate = '';
  /** Toggle panel below submit row showing daysheet summary from current form state. */
  showTotalSummary = false;
  totalSummaryData: any = null;
  /** Expand/collapse state for total-summary scenario tables (Breakfast expanded by default). */
  private summaryScenarioExpanded: Record<string, boolean> = {};
  /** Total summary view toggle: 'all' shows Today's Menu + combined table, 'summary' shows per-scenario boxes. */
  summaryViewMode: 'all' | 'summary' = 'all';
  allSummaryRows: any[] = [];
  allSummaryTotalCost = 0;
  // supplyBuilding//

  constructor(private route: ActivatedRoute, private service: MessService,
    private spinner: NgxSpinnerService,
    private toast: ToastmessageService, private dialog: NgDialogAnimationService, private router: Router,
    private zone: NgZone,) { this.current = new Date(); }

  ngOnInit(): void {
    // Landing shell (MessDetails): params from MessService after list → detail setView
    if (this.router.url.includes('MessDetails')) {
      const fromService = this.service.getDoDetailViewParams();
      if (fromService?.['messBuildingId'] != null && fromService['messBuildingId'] !== '') {
        this.applyDetailParams(fromService);
      }
    }

    // Dedicated /messDoDetailsView route: keep existing queryParams behavior
    this.route.queryParams.subscribe(params => {
      if (params?.['messBuildingId'] == null || params['messBuildingId'] === '') {
        return;
      }
      this.applyDetailParams(params);
    });
  }

  private applyDetailParams(params: Record<string, any>): void {
    this.messBuildingId = params['messBuildingId'];
    this.daysheetDate = params['daysheetDate'];
    this.messBuildingName = params['messBuildingName'];
    this.holidayReason = params['holidayReason'];
    this.status = params['status'];
    console.log('this.holiday', params['holiday']);
    this.holiday = params['holiday'] === true || params['holiday'] === 'true';

    this.selectDate = moment(this.current).format('DD MMM YYYY');
    if (!this.holiday) {
      this.getInventoryDetails();
    }
  }

  closeHoliday() {
    this.navigateBackToMessDoDetails();
  }

  /** Same guard as itemName click / openItemQtyDialog — closed daysheet or holiday date. */
  private isInventoryGridReadOnly(): boolean {
    // return this.isDaysheetSubmitDisabled;
    return this.isClosedDaysheet;
  }

  get isClosedDaysheet(): boolean {
    const s = String(this.status ?? '').trim().toUpperCase();
    return s === 'CLOSED' || s === 'CLOSE';
  }

  /** Only full CLOSED locks Total Summary; CLOSE may still open the summary panel. */
  get isDaysheetClosedLocked(): boolean {
    return String(this.status ?? '').trim().toUpperCase() === 'CLOSED';
  }

  backToMessDoDetails(): void {
    this.navigateBackToMessDoDetails();
  }

  /** Prefer landing setView when on MessDetails; otherwise keep /messDoDetails route. */
  private navigateBackToMessDoDetails(): void {
    if (this.router.url.includes('MessDetails')) {
      this.service.clearDoDetailViewParams();
      this.service.setView('messDoDetails');
      return;
    }
    this.router.navigate(['/messDoDetails']);
  }

  toggleSupplyBuildingTable(): void {
    this.supplyBuildingTableExpanded = !this.supplyBuildingTableExpanded;
  }

  private mergeInventoryDetailsFromServer(): void {
    const inv = this.inventroyData;
    if (!inv || typeof inv !== 'object') {
      this.scenarioBasedMenuItemsList = [];
      this.refreshInventoryEditableCells();
      return;
    }

    const statusRaw = inv.status;
    this.daysheetStatus = String(statusRaw ?? '').trim();

    const dateKey = this.lastInventoryDetailsDate || this.selectDate || moment(this.current).format('DD MMM YYYY');
    if (this.daysheetStatus) {
      this.daysheetStatusByDate.set(dateKey, this.daysheetStatus.toUpperCase());
    }

    const scenarioList = this.getScenarioBasedMenuItemsListFromInventory(inv);
    if (scenarioList.length) {
      this.scenarioBasedMenuItemsList = this.normalizeScenarioBasedMenuItemsList(scenarioList);
    } else {
      this.scenarioBasedMenuItemsList = [];
    }

    const details = this.collectSaveInventoryBalanceDetails(inv);
    if (Array.isArray(details) && details.length && Array.isArray(this.rowData) && this.rowData.length) {
      const byId = new Map<number, any>();
      details.forEach((d: any) => {
        const id = Number(d?.itemId);
        if (Number.isFinite(id)) byId.set(id, d);
      });
      this.rowData = this.rowData.map((row: any) => {
        const d = byId.get(Number(row.itemId));
        if (!d) return this.normalizeInventoryRow(row);
        const merged: any = {
          ...row,
          // API returns onHandQty inside saveInventoryBalanceDetails; show it in Open Balance column
          openBalance: Number(d.onHandQty ?? d.openBalance ?? row.openBalance ?? 0),
          bfQty: Number(d.bfQty ?? row.bfQty ?? 0),
          lunchQty: Number(d.lunchQty ?? row.lunchQty ?? 0),
          snacksQty: Number(d.snacksQty ?? row.snacksQty ?? 0),
          DinnerQty: Number(d.dinnerQty ?? d.DinnerQty ?? row.DinnerQty ?? 0),
          ratePerUnit: Number(d.ratePerUnit ?? row.ratePerUnit ?? 0),
          itemStatus: String(d.itemStatus ?? row.itemStatus ?? '1'),
        };
        if (merged.itemStatus === '0') {
          merged.bfQty = 0;
          merged.lunchQty = 0;
          merged.snacksQty = 0;
          merged.DinnerQty = 0;
        }
        const n = this.normalizeInventoryRow(merged);
        const totalQty =
          Number(n.bfQty ?? 0) +
          Number(n.lunchQty ?? 0) +
          Number(n.snacksQty ?? 0) +
          Number(n.DinnerQty ?? 0);
        const openBal = Number(n?.openBalance ?? 0);
        const rate = Number(n.ratePerUnit ?? 0);
        n.totalQty = totalQty;
        n.totalAmount = Number((totalQty * rate).toFixed(2));
        n.closedBalance = Number((openBal - totalQty).toFixed(2));
        return n;
      });
    }

    if (Array.isArray(inv.supplyBuildings) && inv.supplyBuildings.length > 0) {
      this.BuildingDetails = inv.supplyBuildings.map((r: any) => ({
        ...r,
        scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
        studentCount: Number(r.studentCount ?? 0),
        employeeCount: Number(r.employeeCount ?? 0),
        subStaffCount: Number(r.subStaffCount ?? 0),
        visitorsCount: Number(r.visitorsCount ?? 0),
      }));
    } else if (!this.isSupplyBuildingSubmittedForCurrentDate()) {
      this.BuildingDetails = [];
      this.supplyBuildingSubmittedForDate = '';
    }
    this.refreshInventoryEditableCells();
  }

  private getScenarioBasedMenuItemsListFromInventory(inv: any): any[] {
    const list = inv?.ScenarioBasedMenuItemsList ?? inv?.scenarioBasedMenuItemsList;
    return Array.isArray(list) ? list : [];
  }

  private normalizeScenarioBasedMenuItemsList(rawList: any[]): ScenarioBasedMenuItemPayload[] {
    return rawList
      .map((scenario) => ({
        scenarioId: Number(scenario?.scenarioId),
        scenarioName: String(scenario?.scenarioName ?? '').trim(),
        daysheetMenuItemsList: this.normalizeDaysheetMenuItemsList(scenario?.daysheetMenuItemsList),
        saveInventoryBalanceDetails:
          scenario?.saveInventoryBalanceDetails ?? scenario?.SaveInventoryBalanceDetails ?? [],
      }))
      .filter((scenario) => Number.isFinite(scenario.scenarioId) && !!scenario.scenarioName);
  }

  private normalizeDaysheetMenuItemsList(rawList: unknown): {
    daysheetMenuItemName: string;
    daysheetMenuItemId: number;
    status?: string;
    itemStatus?: string;
  }[] {
    if (!Array.isArray(rawList)) {
      return [];
    }
    return rawList
      .map((item: any) => {
        const status = String(item?.status ?? '1').trim() || '1';
        return {
          daysheetMenuItemId: Number(item?.daysheetMenuItemId ?? item?.DaysheetMenuItemId),
          daysheetMenuItemName: String(item?.daysheetMenuItemName ?? item?.DaysheetMenuItemName ?? '').trim(),
          status,
          itemStatus: String(item?.itemStatus ?? status).trim() || status,
        };
      })
      .filter((item) => Number.isFinite(item.daysheetMenuItemId) && !!item.daysheetMenuItemName);
  }

  private collectSaveInventoryBalanceDetails(inv: any): any[] {
    const scenarioList = this.getScenarioBasedMenuItemsListFromInventory(inv);
    if (!scenarioList.length) {
      return Array.isArray(inv?.saveInventoryBalanceDetails) ? inv.saveInventoryBalanceDetails : [];
    }

    const byItemId = new Map<number, any>();
    scenarioList.forEach((scenario) => {
      const details = scenario?.saveInventoryBalanceDetails ?? scenario?.SaveInventoryBalanceDetails;
      if (!Array.isArray(details)) {
        return;
      }
      details.forEach((d: any) => {
        const id = Number(d?.itemId);
        if (!Number.isFinite(id)) {
          return;
        }
        const existing = byItemId.get(id);
        if (!existing) {
          byItemId.set(id, {
            ...d,
            itemStatus: String(d?.itemStatus ?? '1'),
            bfQty: Number(d?.bfQty ?? 0),
            lunchQty: Number(d?.lunchQty ?? 0),
            snacksQty: Number(d?.snacksQty ?? 0),
            dinnerQty: Number(d?.dinnerQty ?? d?.DinnerQty ?? 0),
          });
          return;
        }
        if (Number(d?.bfQty ?? 0) > 0) {
          existing.bfQty = Number(d.bfQty);
        }
        if (Number(d?.lunchQty ?? 0) > 0) {
          existing.lunchQty = Number(d.lunchQty);
        }
        if (Number(d?.snacksQty ?? 0) > 0) {
          existing.snacksQty = Number(d.snacksQty);
        }
        const dinnerQty = Number(d?.dinnerQty ?? d?.DinnerQty ?? 0);
        if (dinnerQty > 0) {
          existing.dinnerQty = dinnerQty;
        }
        existing.ratePerUnit = Number(d?.ratePerUnit ?? existing.ratePerUnit ?? 0);
        existing.itemStatus = String(d?.itemStatus ?? existing.itemStatus ?? '1');
      });
    });
    return Array.from(byItemId.values());
  }

  private refreshInventoryEditableCells(): void {
    this.gridApi?.refreshCells({
      columns: ['itemName', 'bfQty', 'lunchQty', 'snacksQty', 'DinnerQty'],
      force: true,
    });
  }

  getInventoryDetails() {
    this.spinner.show();
    this.gridApi?.showLoadingOverlay();
    this.service.InventoryDetails(this.messBuildingId, this.daysheetDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          this.gridApi?.showNoRowsOverlay();
          this.rowData = [];
          return;
        }
        // Backward compatible:
        // - older API: res is array of grid rows
        // - newer API: res is object with saveInventoryBalanceDetails + supplyBuildings
        if (Array.isArray(res)) {
          this.rowData = res.map((r: any) => this.normalizeInventoryRow(r));
          this.inventroyData = null;
          this.refreshInventoryEditableCells();
        } else {
          this.inventroyData = res;
          this.lastInventoryDetailsDate = String(this.daysheetDate ?? '').trim();
          this.daysheetStatus = String(res?.status ?? '').trim();

          const scenarioList = this.getScenarioBasedMenuItemsListFromInventory(res);
          if (scenarioList.length) {
            this.scenarioBasedMenuItemsList = this.normalizeScenarioBasedMenuItemsList(scenarioList);
          } else {
            this.scenarioBasedMenuItemsList = [];
          }

          const details = this.collectSaveInventoryBalanceDetails(res);
          // Build grid rows directly from saveInventoryBalanceDetails (no extra API calls)
          this.rowData = details.map((d: any) => {
            const openBal = Number(d?.onHandQty ?? d?.openBalance ?? 0);
            const bfQty = Number(d?.bfQty ?? 0);
            const lunchQty = Number(d?.lunchQty ?? 0);
            const snacksQty = Number(d?.snacksQty ?? 0);
            const DinnerQty = Number(d?.dinnerQty ?? d?.DinnerQty ?? 0);
            const totalQty = bfQty + lunchQty + snacksQty + DinnerQty;
            const rate = Number(d?.ratePerUnit ?? 0);
            return this.normalizeInventoryRow({
              ...d,
              itemId: d?.itemId,
              itemFusionId: d?.itemFusionId,
              // API sends itemNameEn / itemNameTe; keep legacy fields as fallback
              itemName: this.cleanItemNameText(d?.itemNameEn ?? d?.itemName ?? ''),
              teluguItemName: this.cleanItemNameText(d?.itemNameTe ?? d?.teluguItemName ?? ''),
              openBalance: openBal,
              bfQty,
              lunchQty,
              snacksQty,
              DinnerQty,
              totalQty,
              ratePerUnit: rate,
              totalAmount: Number((totalQty * rate).toFixed(2)),
              closedBalance: Number((openBal - totalQty).toFixed(2)),
            });
          });

          // supplyBuildings -> Supply Building table
          if (Array.isArray(res?.supplyBuildings) && res.supplyBuildings.length > 0) {
            this.BuildingDetails = res.supplyBuildings.map((r: any) => ({
              ...r,
              scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
              studentCount: Number(r.studentCount ?? 0),
              employeeCount: Number(r.employeeCount ?? 0),
              subStaffCount: Number(r.subStaffCount ?? 0),
              visitorsCount: Number(r.visitorsCount ?? 0),
            }));
          } else if (!this.isSupplyBuildingSubmittedForCurrentDate()) {
            this.BuildingDetails = [];
            this.supplyBuildingSubmittedForDate = '';
          }
        }

        this.updatePinnedBottomRow();
        if (!Array.isArray(this.inventroyData?.supplyBuildings) || this.inventroyData?.supplyBuildings?.length === 0) {
          // this.getSupplyBuilding();
        }
        console.log('res', res);
        this.gridApi?.hideOverlay();
        this.spinner.hide();
        this.refreshInventoryEditableCells();
      },
      error: (err: any) => {
        this.spinner.hide();
        this.gridApi?.hideOverlay();
      }
    })
  }

  /** Strip invisible/bidi control chars the API wraps around item names. */
  private cleanItemNameText(value: any): string {
    return String(value ?? '')
      .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '')
      .trim();
  }

  /** Normalize meal qty defaults and numeric fields when loading rows */
  private normalizeInventoryRow(row: any): any {
    const n = (v: any) => {
      const x = Number(v);
      return Number.isFinite(x) ? x : 0;
    };
    const bfQty = n(row?.bfQty);
    const lunchQty = n(row?.lunchQty);
    const snacksQty = n(row?.snacksQty);
    const DinnerQty = n(row?.DinnerQty);
    const openBalance = n(row?.openBalance);
    const totalQty = bfQty + lunchQty + snacksQty + DinnerQty;
    const out: any = {
      ...row,
      bfQty,
      lunchQty,
      snacksQty,
      DinnerQty,
      totalQty
    };
    if (totalQty === 0) {
      out.totalAmount = 0;
      out.closedBalance = openBalance;
    }
    return out;
  }

  // ✅ Only totalAmount in pinned bottom row
  updatePinnedBottomRow(): void {
    // CellRenderer input handlers are native DOM listeners and may run outside Angular.
    // Ensure pinned total updates are applied inside Angular change detection.
    this.zone.run(() => {
      const totalAmount = this.rowData.reduce(
        (s: number, r: any) => s + Number(r.totalAmount ?? 0), 0
      );
      this.totalAmountValue = totalAmount;
      this.pinnedBottomRowData = [{
        itemName: 'Total',
        openBalance: null,
        bfQty: null,
        lunchQty: null,
        snacksQty: null,
        DinnerQty: null,
        totalQty: null,
        ratePerUnit: null,
        totalAmount: totalAmount, // ✅ only this shows
        closedBalance: null,
      }];
    });
  }


  /** Refresh only computed columns so meal-qty inputs are not torn down (Tab / Enter focus works). */
  private refreshInventoryDerivedColumns(params: any): void {
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: ['totalQty', 'totalAmount', 'closedBalance'],
      force: true,
    });
  }

  /**
   * Shared meal qty commit (used on blur and on Tab/Enter).
   * Mutates row data + refreshes derived columns only (avoids re-rendering meal inputs mid-keydown).
   * @returns true if values were applied; false if validation failed (caller should not advance focus).
   */
  applyMealQtyChange(
    params: any,
    field: MealQtyField,
    rawText: string,
    inputEl: HTMLInputElement | null,
  ): boolean {
    if (this.isInventoryGridReadOnly()) {
      return false;
    }
    const openBal = Number(params.data?.openBalance ?? 0);
    const trimmed = String(rawText ?? '').trim();
    const val = parseFloat(trimmed);

    if (isNaN(val) || trimmed === '') {
      alert('❌ Please enter numbers only');
      if (inputEl) {
        const prev = (params.node.data as any)?.[field];
        inputEl.value = this.formatMealQtyInputDisplay(prev);
      }
      return false;
    }

    if (val < 0) {
      alert('❌ Consumed Qty must be greater than or equal to 0');
      if (inputEl) {
        const prev = (params.node.data as any)?.[field];
        inputEl.value = this.formatMealQtyInputDisplay(prev);
      }

      return false;
    }

    const d = params.node.data as any;
    d[field] = val;

    const breakfast = Number(d?.bfQty ?? 0);
    const lunch = Number(d?.lunchQty ?? 0);
    const snacksQty = Number(d?.snacksQty ?? 0);
    const dinnerQty = Number(d?.DinnerQty ?? 0);
    const totalQty = breakfast + lunch + snacksQty + dinnerQty;

    if (totalQty > openBal) {
      this.showOpenBalanceExceededDialog(totalQty, openBal);

      d[field] = 0;
      const updatedBreakfast = Number(d?.bfQty ?? 0);
      const updatedLunch = Number(d?.lunchQty ?? 0);
      const updatedSnacks = Number(d?.snacksQty ?? 0);
      const updatedDinner = Number(d?.DinnerQty ?? 0);
      const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

      const ratePerUnit = Number(d?.ratePerUnit ?? 0);
      const totalAmount = validTotal * ratePerUnit;
      const closingBal = openBal - validTotal;

      d.totalAmount = Number(totalAmount.toFixed(2));
      d.closedBalance = Number(closingBal.toFixed(2));

      this.refreshInventoryDerivedColumns(params);
      if (inputEl) inputEl.value = this.formatMealQtyInputDisplay(0);
      this.updatePinnedBottomRow();
      return false;
    }

    const ratePerUnit = Number(d?.ratePerUnit ?? 0);
    const totalAmount = totalQty * ratePerUnit;
    const closingBal = openBal - totalQty;

    d.totalAmount = Number(totalAmount.toFixed(2));
    d.closedBalance = Number(closingBal.toFixed(2));

    this.refreshInventoryDerivedColumns(params);
    if (inputEl) {
      inputEl.value = this.formatMealQtyInputDisplay(d[field]);
    }
    this.updatePinnedBottomRow();
    return true;
  }

  /** Empty when qty is 0 so placeholder "0" shows in meal-qty inputs. */
  private formatMealQtyInputDisplay(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) {
      return '';
    }
    return String(value);
  }

  private isMealQtyControlCombo(e: KeyboardEvent): boolean {
    return e.ctrlKey || e.metaKey;
  }

  private isMealQtyAllowedNonDigitKey(e: KeyboardEvent): boolean {
    const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Enter'];
    return allowed.includes(e.key) || this.isMealQtyControlCombo(e);
  }

  /** After a successful commit, move focus along bf → lunch → snacks → dinner → next row bf (Shift+Tab / Shift+Enter backward). */
  private moveMealQtyFocusAfterCommit(
    params: any,
    field: MealQtyField,
    input: HTMLInputElement,
    delta: number,
  ): void {
    (input as any).__mealSkipBlur = true;
    const rowId = String(params.node.id);
    const order = MEAL_QTY_FIELDS as readonly string[];
    const idx = order.indexOf(field);
    const moveFocus = () => {
      const nextIdx = idx + delta;
      if (nextIdx >= 0 && nextIdx < order.length) {
        const next = document.querySelector(
          `input[data-inv-row-id="${rowId}"][data-meal-qty="${order[nextIdx]}"]`,
        ) as HTMLInputElement;
        next?.focus();
        return;
      }
      if (delta === 1) {
        const allBf: HTMLInputElement[] = [];
        document.querySelectorAll('input[data-meal-qty="bfQty"]').forEach((el) => allBf.push(el as HTMLInputElement));
        const cur = allBf.findIndex((el) => el.getAttribute('data-inv-row-id') === rowId);
        if (cur >= 0 && cur + 1 < allBf.length) {
          allBf[cur + 1].focus();
        }
        return;
      }
      const allDn: HTMLInputElement[] = [];
      document.querySelectorAll('input[data-meal-qty="DinnerQty"]').forEach((el) => allDn.push(el as HTMLInputElement));
      const curD = allDn.findIndex((el) => el.getAttribute('data-inv-row-id') === rowId);
      if (curD > 0) {
        allDn[curD - 1].focus();
      }
    };
    requestAnimationFrame(() => requestAnimationFrame(moveFocus));
  }

  /** Tab / Enter: commit then move to next meal input in the same row (Enter always forward). */
  handleMealQtyKeydown(e: KeyboardEvent, input: HTMLInputElement, field: MealQtyField, params: any): void {
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const rawForCommit = input.value.trim() === '' ? '0' : input.value;
      const committed = this.applyMealQtyChange(params, field, rawForCommit, input);
      if (!committed) {
        return;
      }
      input.value = this.formatMealQtyInputDisplay((params.node.data as any)?.[field]);
      const delta = e.key === 'Enter' ? 1 : e.shiftKey ? -1 : 1;
      this.moveMealQtyFocusAfterCommit(params, field, input, delta);
      return;
    }

    if (this.isMealQtyAllowedNonDigitKey(e)) return;
    if (/^[0-9]$/.test(e.key)) return;
    if (e.key === '.') return;
    e.preventDefault();
  }

  /** Allow digits and a single decimal point (e.g. 30.5); strips other characters and extra dots. */
  private sanitizeMealQtyInput(el: HTMLInputElement): void {
    let v = el.value.replace(/[^0-9.]/g, '');
    const dot = v.indexOf('.');
    if (dot !== -1) {
      v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, '');
    }
    if (el.value !== v) el.value = v;
  }

  /**
   * Live totals while typing: updates row data and refreshes only derived columns so the
   * focused meal input is not destroyed (avoids losing focus).
   */
  private syncLiveMealTotalsFromInput(params: any, field: MealQtyField, input: HTMLInputElement): void {
    if (this.isInventoryGridReadOnly()) {
      return;
    }
    this.sanitizeMealQtyInput(input);
    const d = params.node.data as any;
    const raw = input.value.trim();
    if (raw !== '' && isNaN(parseFloat(raw))) {
      return;
    }
    const curNum = raw === '' ? 0 : parseFloat(raw);
    const bf = field === 'bfQty' ? curNum : Number(d?.bfQty ?? 0);
    const lunch = field === 'lunchQty' ? curNum : Number(d?.lunchQty ?? 0);
    const snacks = field === 'snacksQty' ? curNum : Number(d?.snacksQty ?? 0);
    const dinner = field === 'DinnerQty' ? curNum : Number(d?.DinnerQty ?? 0);
    const openBal = Number(d?.openBalance ?? 0);
    const totalQty = bf + lunch + snacks + dinner;
    if (totalQty > openBal) {
      const prevVal = Number(d?.[field] ?? 0);
      this.showOpenBalanceExceededDialog(totalQty, openBal);
      input.value = this.formatMealQtyInputDisplay(prevVal);
      return;
    }
    const rate = Number(d?.ratePerUnit ?? 0);
    d.bfQty = bf;
    d.lunchQty = lunch;
    d.snacksQty = snacks;
    d.DinnerQty = dinner;
    d.totalAmount = Number((totalQty * rate).toFixed(2));
    d.closedBalance = Number((openBal - totalQty).toFixed(2));
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: ['totalQty', 'totalAmount', 'closedBalance'],
      force: true,
    });
    this.updatePinnedBottomRow();
  }

  /** Shared cell renderer for Breakfast / Lunch / Snacks / Dinner qty: Tab order + calculations. */
  mealQtyCellRenderer(params: any, field: MealQtyField): HTMLElement | string {
    if (params.node.rowPinned) {
      return '';
    }
    const input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'decimal';
    input.autocomplete = 'off';
    input.placeholder = '0';
    input.className = 'mess-do-detail-meal-qty-input';
    input.value = this.formatMealQtyInputDisplay(params.value);
    input.style.width = '100%';
    input.style.padding = '0px 4px';
    input.style.fontSize = '14px';
    input.style.textAlign = 'right';
    input.style.border = '1px solid #ddd';
    input.style.height = '30px';
    input.style.borderRadius = '4px';
    input.setAttribute('data-inv-row-id', String(params.node.id));
    input.setAttribute('data-meal-qty', field);

    if (this.isInventoryGridReadOnly()) {
      input.disabled = true;
      input.style.cursor = 'not-allowed';
      input.style.backgroundColor = '#f3f4f6';
      input.style.border = '1px solid #e5e7eb';
    } else if ((params.data.openBalance ?? 0) === 0) {
      input.disabled = true;
      input.style.border = '2px solid red';
    }

    input.addEventListener('click', (e) => e.stopPropagation());

    input.addEventListener('keydown', (e: KeyboardEvent) =>
      this.handleMealQtyKeydown(e, input, field, params),
    );

    input.addEventListener('input', () => {
      this.syncLiveMealTotalsFromInput(params, field, input);
    });

    input.addEventListener('blur', () => {
      if ((input as any).__mealSkipBlur) {
        (input as any).__mealSkipBlur = false;
        return;
      }
      const raw = input.value.trim() === '' ? '0' : input.value;
      const committed = this.applyMealQtyChange(params, field, raw, input);
      if (committed) {
        input.value = this.formatMealQtyInputDisplay((params.node.data as any)?.[field]);
      }
    });

    input.tabIndex = 0;
    params.eGridCell.tabIndex = -1;
    params.eGridCell.addEventListener('focus', () => input.focus());

    input.addEventListener('focus', (e: Event) => {
      const t = e.target as HTMLInputElement;
      const val = t.value;
      setTimeout(() => t.setSelectionRange(val.length, val.length));
    });

    return input;
  }
  // 24/04/2026

  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }

  onstudentMeals(e: any) {
    console.log(e, 'e');
  }

  onfilterChange(event: any) {
    this.quickFilter = event.target.value;
  }

  onItemNameLangChange(): void {
    this.gridApi?.refreshCells({ columns: ['itemName'], force: true });
  }

  /** Open same right-side dialog as Next(), in item mode: image 150×150 + meal qty inputs. */
  openItemQtyDialog(node: any): void {
    if (!node || node.rowPinned || !node?.data) {
      return;
    }
    if (this.isInventoryGridReadOnly()) {
      return;
    }
    // AG Grid cellRenderer uses native DOM click — run inside Angular zone so dialog content renders.
    this.zone.run(() => {
      const dialogRef = this.dialog.open(SupplyBuildingDialogComponent, {
        width: '30%',
        height: '100%',
        data: {
          mode: 'item',
          row: { ...node.data },
          buildingId: this.messBuildingId,
          currentDate: this.daysheetDate,
          itemNameDisplayLang: this.itemNameDisplayLang,
        },
        panelClass: 'mess-inventory-right-dialog',
        position: { right: '0px' },
        animation: { to: 'left' },
        maxWidth: '100%',
        autoFocus: false,
        restoreFocus: false,
        disableClose: true,
        hasBackdrop: true,
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        if (!res || res.mode !== 'item') {
          return;
        }
        this.applyDialogQuantitiesToRow(res);
      });
    });
  }


  private applyDialogQuantitiesToRow(q: any): void {
    const idx = this.rowData.findIndex((r: any) => Number(r?.itemId) === Number(q.itemId));
    if (idx < 0) {
      return;
    }
    const row = this.rowData[idx];
    const openBal = Number(row?.openBalance ?? 0);
    const bf = Number(q.bfQty ?? 0);
    const lunch = Number(q.lunchQty ?? 0);
    const snacks = Number(q.snacksQty ?? 0);
    const dinner = Number(q.DinnerQty ?? 0);
    const totalQty = bf + lunch + snacks + dinner;
    if (totalQty > openBal) {
      this.showOpenBalanceExceededDialog(totalQty, openBal);
      return;
    }
    this.zone.run(() => {
      row.bfQty = bf;
      row.lunchQty = lunch;
      row.snacksQty = snacks;
      row.DinnerQty = dinner;
      const rate = Number(row.ratePerUnit ?? 0);
      row.totalAmount = Number((totalQty * rate).toFixed(2));
      row.closedBalance = Number((openBal - totalQty).toFixed(2));
      this.rowData = [...this.rowData];
      this.gridApi?.refreshCells({ force: true });
      this.updatePinnedBottomRow();
    });
  }


  private showOpenBalanceExceededDialog(totalQty: number, openBal: number): void {
    const openDialog = () => {
      this.dialog.open(ConfirmationMessageDialogComponent, {
        width: '400px',
        maxWidth: '92vw',
        autoFocus: false,
        restoreFocus: true,
        data: {
          title: 'Open Balance Exceeded',
          message: `Total Consumed (${totalQty}) cannot exceed Open Balance (${openBal}).`,
          confirmLabel: 'OK',
          confirmResult: 'ok',
          singleAction: true,
        },
      });
    };
    this.zone.run(openDialog);
  }

  colDefs: ColDef[] = [

    {
      headerName: 'S.No',
      pinned: 'left',
      width: 70,
      cellStyle: { 'text-align': 'center', 'font-size': '16px' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      valueGetter: (params: any) => params.node.rowIndex + 1, // ✅ 1, 2, 3...
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return params.value;
      }
    },
    {
      field: 'itemName',
      headerName: 'Item Name',
      pinned: 'left',
      width: 350,
      cellStyle: { 'text-align': 'left', 'font-size': '16px', color: 'rgb(24 64 121)', 'font-weight': '500' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;

        // ✅ pinned bottom row — show "Total : <total cost>" in Item Name column
        if (params.node.rowPinned) {
          const bold = document.createElement('strong');
          bold.innerText = 'Total : ' + this.inrGroupedNumber(params.data?.totalAmount);
          bold.style.color = '#0b3f78';
          bold.style.fontSize = '14px';
          return bold;
        }
        const fusionItemId = params.data?.itemFusionId;
        const imageUrl = fusionItemId
          ? `http://mess-images.s3.ap-south-1.amazonaws.com/medium/${fusionItemId}.jpg`
          : null;

        // ✅ wrapper div — flex row (click opens item qty dialog)
        const wrapper = document.createElement('div');
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'center';
        wrapper.style.gap = '8px';
        wrapper.style.height = '100%';
        wrapper.style.color = '#FFA50A';
        if (!this.isInventoryGridReadOnly()) {
          wrapper.style.cursor = 'pointer';
          wrapper.addEventListener('click', (ev: MouseEvent) => {
            ev.stopPropagation();
            this.openItemQtyDialog(params.node);
          });
        }

        // ✅ image or placeholder
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          const displayLabel =
            this.itemNameDisplayLang === 'te'
              ? String(params.data?.teluguItemName ?? params.value ?? '')
              : String(params.data?.itemName ?? params.value ?? '');
          img.alt = displayLabel;
          img.style.width = '35px';
          img.style.height = '35px';
          img.style.borderRadius = '4px';
          img.style.objectFit = 'cover';
          img.style.flexShrink = '0';

          // ✅ fallback if image not found
          img.onerror = () => {
            img.style.display = 'none';
          };

          wrapper.appendChild(img);
        }

        // ✅ item name text (English or Telugu from dropdown)
        const span = document.createElement('span');
        span.innerText =
          this.itemNameDisplayLang === 'te'
            ? String(params.data?.teluguItemName ?? params.value ?? '')
            : String(params.data?.itemName ?? params.value ?? '');
        span.style.color = 'rgb(24 64 121)';
        span.style.overflow = 'hidden';
        span.style.textOverflow = 'ellipsis';
        span.style.whiteSpace = 'nowrap';
        wrapper.appendChild(span);

        return wrapper;
      }
    },

    {
      field: 'itemFusionId',
      headerName: 'Fusion Id',
      pinned: 'left',
      width: 150,
      hide: false,
      // filter: 'agTextColumnFilter',
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        return params.value;
      }
    },

    {
      field: 'openBalance',
      headerName: 'Open Balance Qty',
      width: 170,
      minWidth: 150,
      maxWidth: 170,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-do-detail-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        return this.inrGroupedNumber(params.value);
      }
    },
    {
      field: 'bfQty',
      headerName: 'Breakfast Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'bfQty'),
      headerClass: 'mess-do-detail-header-center',
    },
    {
      field: 'lunchQty',
      headerName: 'Lunch Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'lunchQty'),
      headerClass: 'mess-do-detail-header-center',
    },
    {
      field: 'snacksQty',
      headerName: 'Snacks Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'snacksQty'),
      headerClass: 'mess-do-detail-header-center',
    },
    {
      field: 'DinnerQty',
      headerName: 'Dinner Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'DinnerQty'),
      headerClass: 'mess-do-detail-header-center',
    },

    // TotalQty //

    {
      colId: 'totalQty',
      headerName: 'Total Qty',
      width: 120,
      minWidth: 110,
      maxWidth: 130,
      valueGetter: (p) => {
        const d = p.data;
        if (!d) return 0;
        return (
          Number(d.bfQty ?? 0) +
          Number(d.lunchQty ?? 0) +
          Number(d.snacksQty ?? 0) +
          Number(d.DinnerQty ?? 0)
        );
      },
      valueFormatter: (p) => this.inrGroupedNumber(p.value),
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-do-detail-header-center',
      suppressKeyboardEvent: () => true,
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        const d = params.data;
        const sum =
          Number(d?.bfQty ?? 0) +
          Number(d?.lunchQty ?? 0) +
          Number(d?.snacksQty ?? 0) +
          Number(d?.DinnerQty ?? 0);
        return this.inrGroupedNumber(sum);
      },
    },

    {
      field: 'ratePerUnit',
      headerName: 'Rate (₹)',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      headerClass: 'mess-do-detail-header-center',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return this.inrGroupedNumber(params.value);
      }
    },

    {
      colId: 'totalAmount',
      field: 'totalAmount',
      headerName: 'Total Cost (₹)',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-do-detail-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) {
          return '';
        }
        return this.inrGroupedNumber(params.value);
      }
    },

    {
      field: 'closedBalance',
      headerName: 'Closed Balance Qty',
      width: 180,
      minWidth: 180,
      maxWidth: 200,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-do-detail-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return this.inrGroupedNumber(params.value);
      }
    },
  ];


  rowData: PeriodicElement2[] = [];
  pinnedBottomRowData: any[] = [];
  // pinnedTopRowData: PeriodicElement2[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    menuTabs: [],
    suppressHeaderMenuButton: true,
    sortable: true,
    filter: false,
    headerClass: 'mess-do-detail-header-center',
  };

  // ✅ custom overlay text
  overlayLoadingTemplate = `
    <span class="ag-overlay-loading-center">
      Please wait while data is loading...
    </span>`;

  overlayNoRowsTemplate = `
    <span>No data found</span>`;

  onCellValueChanged(event: CellValueChangedEvent<PeriodicElement2>) {
    const editableFields = ['bfQty', 'lunchQty', 'snacksQty', 'DinnerQty', 'ratePerUnit'];
    if (!editableFields.includes(event.colDef.field!)) return;

    const openBal = Number(event.data?.openBalance ?? 0);
    const ratePerUnit = Number(event.data?.ratePerUnit ?? 0);

    // Get all entered quantities
    const breakfast = Number(event.data?.bfQty ?? 0);
    const lunch = Number(event.data?.lunchQty ?? 0);
    const snacks = Number(event.data?.snacksQty ?? 0);
    const dinner = Number(event.data?.DinnerQty ?? 0);

    const totalQty = breakfast + lunch + snacks + dinner;

    // 🚨 If totalQty exceeds openBalance, show alert but continue
    if (totalQty > openBal) {
      this.showOpenBalanceExceededDialog(totalQty, openBal);
      return;
    }

    // ✅ Calculate totals regardless
    const totalAmount = totalQty * ratePerUnit;
    const closedBalance = openBal - totalQty;

    // Update the calculated fields
    event.node.setDataValue('totalAmount', totalAmount.toFixed(2));
    event.node.setDataValue('closedBalance', closedBalance.toFixed(2));

    // Refresh UI
    event.api.refreshCells({ rowNodes: [event.node], force: true });
    this.updatePinnedBottomRow();

    // console.log(
    //   `Updated | totalQty=${totalQty}, totalAmount=${totalAmount}, closedBalance=${closedBalance}`
    // );
  }

  preparePayload(options?: { status?: string }) {
    this.flushMealQtyFromGrid();
    const payload: any = {
      buildingId: this.messBuildingId,
      inventoryDate: this.daysheetDate,
      studentCount: this.totalStudents,
      employeeCount: this.totalEmployee,
      subStaffCount: this.totalSubStaff,
      visitorsCount: this.totalVisitors,
      status: options?.status ?? 'CLOSED',
      daysheetAmount: this.totalAmountValue,
      supplyBuildings: this.BuildingDetails.map((r: any) => ({
        supplyId: r.supplyId,
        supplyBuildingName: r.supplyBuildingName,
        scaitsStudentCount: this.resolveScaitsStudentCountForPayload(r),
        studentCount: Number(r.studentCount ?? 0),
        employeeCount: Number(r.employeeCount ?? 0),
        subStaffCount: Number(r.subStaffCount ?? 0),
        visitorsCount: Number(r.visitorsCount ?? 0),
      })),
      scenarioBasedMenuItemsList: this.scenarioBasedMenuItemsList.map((scenario) => ({
        scenarioId: String(scenario.scenarioId),
        scenarioName: scenario.scenarioName,
        daysheetMenuItemsList: (scenario.daysheetMenuItemsList ?? []).map((item) => {
          const status = String(item.status ?? item.itemStatus ?? '1');
          return {
            daysheetMenuItemId: item.daysheetMenuItemId,
            daysheetMenuItemName: item.daysheetMenuItemName,
            status,
            itemStatus: String(item.itemStatus ?? status),
          };
        }),
        saveInventoryBalanceDetails: this.buildScenarioSaveInventoryBalanceDetails(scenario),
      })),
    };

    return payload;
  }

  private getScenarioMealQtyField(scenarioName: string): 'bfQty' | 'lunchQty' | 'snacksQty' | 'DinnerQty' {
    const name = String(scenarioName ?? '').trim().toLowerCase();
    if (name.includes('breakfast')) {
      return 'bfQty';
    }
    if (name.includes('lunch')) {
      return 'lunchQty';
    }
    if (name.includes('snack')) {
      return 'snacksQty';
    }
    if (name.includes('dinner')) {
      return 'DinnerQty';
    }
    return 'bfQty';
  }

  private buildScenarioSaveInventoryBalanceDetails(scenario: ScenarioBasedMenuItemPayload): any[] {
    const stored = scenario.saveInventoryBalanceDetails;
    if (Array.isArray(stored) && stored.length) {
      return stored
        .map((d: any) => {
          const itemId = Number(d.itemId);
          if (!Number.isFinite(itemId)) {
            return null;
          }
          const row = (this.rowData ?? []).find((item: any) => Number(item.itemId) === itemId);
          const bfQty = Number(row?.bfQty ?? d.bfQty ?? 0);
          const lunchQty = Number(row?.lunchQty ?? d.lunchQty ?? 0);
          const snacksQty = Number(row?.snacksQty ?? d.snacksQty ?? 0);
          const dinnerQty = Number(row?.DinnerQty ?? d.dinnerQty ?? d.DinnerQty ?? 0);
          const totalQty = bfQty + lunchQty + snacksQty + dinnerQty;
          const itemStatus = String(row?.itemStatus ?? d.itemStatus ?? '1');
          if (itemStatus === '0' || totalQty <= 0) {
            return null;
          }
          const ratePerUnit = Number(row?.ratePerUnit ?? d.ratePerUnit ?? 0);
          return {
            itemId,
            itemName: String(row?.itemName ?? d.itemName ?? '').trim(),
            ratePerUnit,
            bfQty,
            lunchQty,
            snacksQty,
            dinnerQty,
            totalQty: Number(d.totalQty ?? totalQty),
            itemFusionId: row?.itemFusionId ?? d.itemFusionId,
            onHandQty: Number(d.onHandQty ?? row?.openBalance ?? 0),
            itemStatus,
          };
        })
        .filter((item) => item != null);
    }

    const qtyField = this.getScenarioMealQtyField(scenario.scenarioName);
    return (this.rowData ?? [])
      .map((item: any) => {
        const bfQty = Number(item.bfQty ?? 0);
        const lunchQty = Number(item.lunchQty ?? 0);
        const snacksQty = Number(item.snacksQty ?? 0);
        const dinnerQty = Number(item.DinnerQty ?? 0);
        const totalQty = bfQty + lunchQty + snacksQty + dinnerQty;
        const scenarioQty = Number(item[qtyField] ?? 0);
        if (!scenarioQty || scenarioQty <= 0) {
          return null;
        }
        const itemStatus = String(item.itemStatus ?? '1');
        if (itemStatus === '0') {
          return null;
        }
        const ratePerUnit = item.ratePerUnit ? Number(item.ratePerUnit) * 1 : 0;
        return {
          itemId: item.itemId,
          itemName: String(item.itemName ?? item.name ?? '').trim(),
          ratePerUnit,
          bfQty: qtyField === 'bfQty' ? scenarioQty : 0,
          lunchQty: qtyField === 'lunchQty' ? scenarioQty : 0,
          snacksQty: qtyField === 'snacksQty' ? scenarioQty : 0,
          dinnerQty: qtyField === 'DinnerQty' ? scenarioQty : 0,
          totalQty,
          itemFusionId: item.itemFusionId,
          onHandQty: Number(item.onHandQty ?? item.openBalance ?? 0),
          itemStatus,
        };
      })
      .filter((item) => item != null);
  }

  /** Commit focused meal-qty inputs and sync live grid row data into rowData before submit. */
  private flushMealQtyFromGrid(): void {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.forEachNode((node) => {
      if (node.rowPinned || !node.data) {
        return;
      }
      const d = node.data as any;
      MEAL_QTY_FIELDS.forEach((field) => {
        const input = document.querySelector(
          `input[data-inv-row-id="${String(node.id)}"][data-meal-qty="${field}"]`,
        ) as HTMLInputElement | null;
        if (!input || input.disabled) {
          return;
        }
        const trimmed = input.value.trim();
        if (trimmed === '' || isNaN(parseFloat(trimmed))) {
          return;
        }
        d[field] = parseFloat(trimmed);
      });
      const bf = Number(d.bfQty ?? 0);
      const lunch = Number(d.lunchQty ?? 0);
      const snacks = Number(d.snacksQty ?? 0);
      const dinner = Number(d.DinnerQty ?? 0);
      const totalQty = bf + lunch + snacks + dinner;
      const openBal = Number(d.openBalance ?? 0);
      const rate = Number(d.ratePerUnit ?? 0);
      d.totalQty = totalQty;
      d.totalAmount = Number((totalQty * rate).toFixed(2));
      d.closedBalance = Number((openBal - totalQty).toFixed(2));
    });
    this.syncRowDataFromGrid();
  }

  private syncRowDataFromGrid(): void {
    if (!this.gridApi) {
      return;
    }
    const liveById = new Map<number, any>();
    this.gridApi.forEachNode((node) => {
      if (node.rowPinned || !node.data) {
        return;
      }
      const id = Number((node.data as any).itemId);
      if (Number.isFinite(id)) {
        liveById.set(id, node.data);
      }
    });
    const merged: any[] = [];
    const seen = new Set<number>();
    (this.rowData ?? []).forEach((row) => {
      const id = Number(row.itemId);
      const live = Number.isFinite(id) ? liveById.get(id) : null;
      merged.push(live ?? row);
      if (Number.isFinite(id)) {
        seen.add(id);
      }
    });
    liveById.forEach((data, id) => {
      if (!seen.has(id)) {
        merged.push(data);
      }
    });
    this.rowData = merged;
  }

  openTotalSummary(): void {
    this.totalSummaryData = this.buildTotalSummaryData();
    this.initSummaryScenarioExpanded();
    this.buildAllSummaryRows();
    this.summaryViewMode = 'all';
    this.showTotalSummary = true;
  }

  closeTotalSummary(): void {
    this.showTotalSummary = false;
    this.summaryScenarioExpanded = {};
  }

  setSummaryViewMode(mode: 'all' | 'summary'): void {
    this.summaryViewMode = mode;
  }

  /** Merge every scenario's inventory rows into one table (keyed by item) for the "All" view. */
  private buildAllSummaryRows(): void {
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    const merged = new Map<string, any>();

    for (const scenario of scenarios) {
      for (const item of scenario?.saveInventoryBalanceDetails ?? []) {
        const key = String(item?.itemId ?? item?.itemName ?? '').trim();
        if (!key) continue;
        const existing = merged.get(key);
        if (!existing) {
          merged.set(key, {
            ...item,
            bfQty: Number(item?.bfQty ?? 0),
            lunchQty: Number(item?.lunchQty ?? 0),
            snacksQty: Number(item?.snacksQty ?? 0),
            dinnerQty: Number(item?.dinnerQty ?? item?.DinnerQty ?? 0),
          });
        } else {
          existing.bfQty += Number(item?.bfQty ?? 0);
          existing.lunchQty += Number(item?.lunchQty ?? 0);
          existing.snacksQty += Number(item?.snacksQty ?? 0);
          existing.dinnerQty += Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
        }
      }
    }

    this.allSummaryRows = Array.from(merged.values()).map((row: any) => {
      const totalQty = row.bfQty + row.lunchQty + row.snacksQty + row.dinnerQty;
      const totalCost = Number((totalQty * Number(row?.ratePerUnit ?? 0)).toFixed(2));
      return { ...row, totalQty, totalCost };
    });

    this.allSummaryTotalCost = Number(
      this.allSummaryRows.reduce((sum, row) => sum + Number(row.totalCost ?? 0), 0).toFixed(2),
    );
  }

  /** Closed Qty = Open Qty − Total Qty (same rule as the inventory grid). */
  getSummaryClosedQty(item: any): number {
    const openQty = Number(item?.onHandQty ?? item?.openBalance ?? 0);
    const totalQty = Number(item?.totalQty ?? 0);
    if (!Number.isFinite(openQty) || !Number.isFinite(totalQty)) {
      return 0;
    }
    return Number((openQty - totalQty).toFixed(2));
  }

  /** "Today's Menu" lines for the All view: scenario name + its active menu item names. */
  getTodaysMenuList(): Array<{ scenarioName: string; menuItems: string }> {
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    return scenarios.map((scenario: any) => ({
      scenarioName: String(scenario?.scenarioName ?? '').trim(),
      menuItems: this.getSummaryMenuLabel(scenario),
    }));
  }

  /** Column header for a scenario's own meal qty in the Summary view (e.g. "Breakfast Qty"). */
  getScenarioMealQtyLabel(scenario: any): string {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    switch (qtyField) {
      case 'bfQty': return 'Breakfast Qty';
      case 'lunchQty': return 'Lunch Qty';
      case 'snacksQty': return 'Snacks Qty';
      default: return 'Dinner Qty';
    }
  }

  /** Item qty for the scenario's own meal column in the Summary view. */
  getScenarioMealQtyValue(scenario: any, item: any): number {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    if (qtyField === 'DinnerQty') {
      return Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
    }
    return Number(item?.[qtyField] ?? 0);
  }

  get totalSummaryPerHeadPrice(): number {
    const data = this.totalSummaryData;
    if (!data) {
      return 0;
    }
    const heads =
      Number(data.studentCount ?? 0) +
      Number(data.employeeCount ?? 0) +
      Number(data.subStaffCount ?? 0) +
      Number(data.visitorsCount ?? 0);
    const total = Number(data.daysheetAmount ?? 0);
    if (!heads || heads <= 0) {
      return 0;
    }
    return Number((total / heads).toFixed(2));
  }

  isSummaryScenarioExpanded(scenario: any): boolean {
    const key = this.getSummaryScenarioKey(scenario);
    return this.summaryScenarioExpanded[key] ?? false;
  }

  toggleSummaryScenarioExpand(scenario: any): void {
    const key = this.getSummaryScenarioKey(scenario);
    this.summaryScenarioExpanded[key] = !this.isSummaryScenarioExpanded(scenario);
  }

  private initSummaryScenarioExpanded(): void {
    this.summaryScenarioExpanded = {};
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    for (const scenario of scenarios) {
      const key = this.getSummaryScenarioKey(scenario);
      this.summaryScenarioExpanded[key] = this.isBreakfastSummaryScenario(scenario);
    }
  }

  private getSummaryScenarioKey(scenario: any): string {
    const id = String(scenario?.scenarioId ?? '').trim();
    if (id) {
      return id;
    }
    return String(scenario?.scenarioName ?? '').trim().toLowerCase();
  }

  private isBreakfastSummaryScenario(scenario: any): boolean {
    const name = String(scenario?.scenarioName ?? '').trim().toLowerCase();
    return name.includes('breakfast') || Number(scenario?.scenarioId) === 13;
  }

  getSummaryMenuLabel(scenario: any): string {
    return this.getActiveSummaryMenuItems(scenario)
      .map((item: any) => item.daysheetMenuItemName)
      .filter((name: string) => !!name)
      .join(', ') || '—';
  }

  getSummaryMenuItemCount(scenario: any): number {
    return this.getActiveSummaryMenuItems(scenario).length;
  }

  getActiveSummaryMenuItems(scenario: any): any[] {
    return (scenario?.daysheetMenuItemsList ?? []).filter(
      (item: any) => String(item?.status ?? item?.itemStatus ?? '1') !== '0',
    );
  }

  getScenarioSummaryTotalCost(scenario: any): number {
    return (scenario?.saveInventoryBalanceDetails ?? []).reduce(
      (sum: number, item: any) => sum + Number(item?.totalCost ?? 0),
      0,
    );
  }

  private buildTotalSummaryData(): any {
    const payload = this.preparePayload({ status: 'CLOSED' });
    const inv = this.inventroyData ?? {};
    const scenarioBasedMenuItemsList = (payload.scenarioBasedMenuItemsList ?? []).map((scenario: any) => ({
      ...scenario,
      saveInventoryBalanceDetails: (scenario.saveInventoryBalanceDetails ?? []).map((item: any) =>
        this.normalizeScenarioSummaryInventoryItem(scenario.scenarioName, item),
      ),
    }));

    return {
      daysheetId: inv.daysheetId ?? null,
      studentCount: payload.studentCount,
      employeeCount: payload.employeeCount,
      subStaffCount: payload.subStaffCount,
      visitorsCount: payload.visitorsCount,
      status: payload.status,
      daysheetAmount: payload.daysheetAmount,
      scenarioBasedMenuItemsList,
      supplyBuildings: payload.supplyBuildings,
    };
  }

  /** Summary view only: each scenario row shows qty in its meal column, others as 0. */
  private normalizeScenarioSummaryInventoryItem(scenarioName: string, item: any): any {
    const qtyField = this.getScenarioMealQtyField(scenarioName);
    const scenarioQty =
      qtyField === 'DinnerQty'
        ? Number(item?.dinnerQty ?? item?.DinnerQty ?? 0)
        : Number(item?.[qtyField] ?? 0);
    const ratePerUnit = Number(item?.ratePerUnit ?? 0);
    const totalQty = scenarioQty;

    return {
      ...item,
      bfQty: qtyField === 'bfQty' ? scenarioQty : 0,
      lunchQty: qtyField === 'lunchQty' ? scenarioQty : 0,
      snacksQty: qtyField === 'snacksQty' ? scenarioQty : 0,
      dinnerQty: qtyField === 'DinnerQty' ? scenarioQty : 0,
      totalQty,
      totalCost: Number((totalQty * ratePerUnit).toFixed(2)),
    };
  }

  daysheetCloseHoliday() {
    const payload = this.preparePayload({ status: 'CLOSED' });
    console.log('payload', payload);
    this.spinner.show();
    this.service.postMessInventory(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        this.toast.showSuccess(res.message);
        this.navigateBackToMessDoDetails();
        console.log('res', res);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.toast.showError(err.error.message);
        this.spinner.hide();
      }
    })
  }

  submit() {
    // if (this.isDaysheetSubmitDisabled || this.isDaysheetClosedLocked) {
    //   return;
    // }
    const heads =
      Number(this.totalStudents ?? 0) +
      Number(this.totalEmployee ?? 0) +
      Number(this.totalSubStaff ?? 0) +
      Number(this.totalVisitors ?? 0);
    if (!heads || heads <= 0) {
      this.toast.showError('Please enter Student / Employee / SubStaff / Visitors count before submitting.');
      return;
    }
    const consumedQty =
      (this.rowData ?? []).reduce((sum: number, r: any) => {
        const bf = Number(r?.bfQty ?? 0);
        const lunch = Number(r?.lunchQty ?? 0);
        const snacks = Number(r?.snacksQty ?? 0);
        const dinner = Number(r?.DinnerQty ?? 0);
        return sum + bf + lunch + snacks + dinner;
      }, 0);
    if (!consumedQty || consumedQty <= 0) {
      this.toast.showError('Please enter Breakfast / Lunch / Snacks / Dinner quantity before submitting.');
      return;
    }
    this.openTotalSummary();
  }

  confirmDaysheetSubmit(): void {
    if (this.isDaysheetSubmitDisabled || this.isClosedDaysheet) {
      return;
    }
    const confirmRef = this.dialog.open(DaysheetcloseConfirmationMessageDialogComponent, {
      width: '400px',
      maxWidth: '92vw',
      autoFocus: false,
      restoreFocus: true,
      data: {
        title: 'Daysheet Close',
        message: 'Are you sure you want to close this daysheet?',
      },
    });
    confirmRef.afterClosed().subscribe((result) => {
      if (result === 'daysheetClose') {
        this.postDaysheetSubmit();
      }
    });
  }

  private postDaysheetSubmit(): void {
    const payload = this.preparePayload({ status: 'CLOSED' });
    console.log('payload', payload);
    this.spinner.show();
    this.service.postMessInventory(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.toast.showSuccess(res.message);
        this.closeTotalSummary();
        this.navigateBackToMessDoDetails();
        console.log('res', res);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.toast.showError(err.error.message);
        this.spinner.hide();
      },
    });
  }



  addItem() {
    if (this.isDaysheetSubmitDisabled) {
      return;
    }
    const dialogRef = this.dialog.open(AddItemDialogComponent, {
      width: '30%',
      height: '100%',
      data: {
        buildingId: this.messBuildingId,
        existingItems: this.rowData
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((selected: any) => {
      if (!selected) return;

      const openBal = Number(selected?.openBalance ?? 0);
      if (!openBal) {
        return; // don't add items with zero open balance
      }

      const selectedItemId = selected?.itemId;
      if (selectedItemId && this.rowData?.some((x: any) => x?.itemId === selectedItemId)) {
        this.toast.showError('Item already exists');
        return; // already exists, don't duplicate
      }
      const newRow: any = {
        itemId: selected?.itemId ?? null,
        itemName: selected?.itemName ?? selected?.name ?? '',
        itemFusionId: selected?.itemFusionId ?? null,
        openBalance: openBal,
        bfQty: 0,
        lunchQty: 0,
        snacksQty: 0,
        DinnerQty: 0,
        ratePerUnit: selected?.ratePerUnit ?? 0,
        totalAmount: 0,
        closedBalance: selected?.closedBalance ?? 0,
      };
      this.rowData = [...(this.rowData ?? []), newRow];
      this.updatePinnedBottomRow(); // ✅ refresh after add
      console.log('row data', this.rowData);
    });

  }

  /** Indian digit grouping (no currency symbol) */
  inrGroupedNumber(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(String(value).replace(/,/g, ''));
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(n);
  }

  /** Indian digit grouping with ₹ prefix (symbol side by side with value). */
  inrCurrencyGrouped(value: any): string {
    const formatted = this.inrGroupedNumber(value);
    if (!formatted) return '';
    return `₹${formatted}`;
  }

  /**
  * Utility: formats numbers (legacy name; uses Indian grouping)
  */
  numFmt(value: any): string {
    return this.inrGroupedNumber(value);
  }

  openMessSummaryDialog(): void {
    const supplyBuildingsForDialog = this.resolveSupplyBuildingsForSummaryDialog();
    const restoreLocalSupplyBuildings = supplyBuildingsForDialog.length > 0;

    const dialogRef = this.dialog.open(MessSummaryDialogComponent, {
      width: '65%',
      height: '100%',
      data: {
        buildingId: this.messBuildingId,
        currentDate: this.daysheetDate,
        daysheetId: this.inventroyData?.daysheetId,
        totalAmountValue: this.totalAmountValue,
        restoreLocalSupplyBuildings,
        supplyBuildings: supplyBuildingsForDialog,
        readOnly: this.status === 'CLOSED' || this.holiday,
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: false,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((selected: any) => {
      this.applySupplyBuildingsFromDialog(selected);
    });
  }

  private getActiveDaysheetDate(): string {
    return String(this.daysheetDate ?? '').trim();
  }

  private isSupplyBuildingSubmittedForCurrentDate(): boolean {
    const date = this.getActiveDaysheetDate();
    return !!date && this.supplyBuildingSubmittedForDate === date;
  }

  /** Prefer getInventoryDetails supplyBuildings; else same-session dialog submit. */
  private resolveSupplyBuildingsForSummaryDialog(): any[] {
    const invBuildings = this.inventroyData?.supplyBuildings;
    if (Array.isArray(invBuildings) && invBuildings.length > 0) {
      return this.cloneSupplyBuildingsForDialog(invBuildings);
    }
    if (this.isSupplyBuildingSubmittedForCurrentDate() && Array.isArray(this.BuildingDetails) && this.BuildingDetails.length) {
      return this.cloneSupplyBuildingsForDialog(this.BuildingDetails);
    }
    return [];
  }

  private cloneSupplyBuildingsForDialog(rows?: any[]): any[] {
    return (rows ?? []).map((r: any) => ({
      supplyId: Number(r?.supplyId ?? 0),
      supplyBuildingName: String(r?.supplyBuildingName ?? '').trim(),
      scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
      studentCount: Number(r?.studentCount ?? 0),
      employeeCount: Number(r?.employeeCount ?? 0),
      subStaffCount: Number(r?.subStaffCount ?? 0),
      visitorsCount: Number(r?.visitorsCount ?? 0),
    }));
  }

  private applySupplyBuildingsFromDialog(selected: any): void {
    if (!selected || !Array.isArray(selected.supplyBuildings)) {
      return;
    }
    this.supplyBuildingSubmittedForDate = this.getActiveDaysheetDate();
    this.BuildingDetails = selected.supplyBuildings.map((r: any) => ({
      ...r,
      scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
      studentCount: Number(r.studentCount ?? 0),
      employeeCount: Number(r.employeeCount ?? 0),
      subStaffCount: Number(r.subStaffCount ?? 0),
      visitorsCount: Number(r.visitorsCount ?? 0),
    }));
  }

  /** Keep API `scaitsStudentCount` (Student Strength) for summary dialog validation. */
  private toScaitsStudentCount(value: unknown): number | null {
    const n = Number(value ?? NaN);
    return Number.isFinite(n) && n >= 0 ? n : null;
  }

  /**
   * Payload always sends numeric `scaitsStudentCount` (e.g. 860).
   * Falls back to inventory API row by supplyId when local row is missing it.
   */
  private resolveScaitsStudentCountForPayload(row: any): number {
    const fromRow = this.toScaitsStudentCount(row?.scaitsStudentCount);
    if (fromRow != null) {
      return fromRow;
    }
    const supplyId = Number(row?.supplyId ?? NaN);
    const invRows = this.inventroyData?.supplyBuildings;
    if (Array.isArray(invRows) && Number.isFinite(supplyId)) {
      const match = invRows.find((x: any) => Number(x?.supplyId) === supplyId);
      const fromInv = this.toScaitsStudentCount(match?.scaitsStudentCount);
      if (fromInv != null) {
        return fromInv;
      }
    }
    return 0;
  }

  Next() {
    const dialogRef = this.dialog.open(SupplyBuildingDialogComponent, {
      width: '40%',
      height: '100%',
      data: {
        buildingId: this.messBuildingId,
        currentDate: this.daysheetDate,
        totalAmountValue: this.totalAmountValue,
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((selected: any) => {
      if (!selected || !Array.isArray(selected.supplyBuildings)) {
        return;
      }
      this.BuildingDetails = selected.supplyBuildings.map((r: any) => ({
        ...r,
        scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
        studentCount: Number(r.studentCount ?? 0),
        employeeCount: Number(r.employeeCount ?? 0),
        subStaffCount: Number(r.subStaffCount ?? 0),
        visitorsCount: Number(r.visitorsCount ?? 0),
      }));
    });
  }

  //25/04/2026 supply building //

  // getSupplyBuilding() {
  //   this.spinner.show();
  //   this.currentDate = this.daysheetDate;
  //   this.service.supplyBuildingDetails(this.messBuildingId, this.currentDate).subscribe({
  //     next: (res: any) => {
  //       if (!res || res == 204) {
  //         this.BuildingDetails = [];
  //         this.spinner.hide();
  //         return;
  //       }
  //       this.BuildingDetails = (Array.isArray(res) ? res : (res?.data ?? [])).map((r: any) => ({
  //         ...r,
  //         studentCount: Number(r.studentCount ?? 0),
  //         employeeCount: Number(r.employeeCount ?? 0),
  //         subStaffCount: Number(r.subStaffCount ?? 0),
  //         visitorsCount: Number(r.visitorsCount ?? 0),
  //       }));
  //       console.log('BuildingDetails', this.BuildingDetails);
  //       this.spinner.hide();
  //     },
  //     error: () => this.spinner.hide()
  //   });
  // }

  onCountChange(): void { }

  get totalCampus(): number {
    return this.BuildingDetails?.length ?? 0;
  }

  get totalHeadCount(): number {
    return this.BuildingDetails?.reduce((sum: number, r: any) =>
      sum +
      Number(r.studentCount ?? 0) +
      Number(r.employeeCount ?? 0) +
      Number(r.subStaffCount ?? 0) +
      Number(r.visitorsCount ?? 0), 0) ?? 0;
  }

  get perHeadPrice(): number {
    const heads = Number(this.totalHeadCount ?? 0);
    const total = Number(this.totalAmountValue ?? 0);
    if (!heads || heads <= 0) return 0;
    return Number((total / heads).toFixed(2));
  }


  get totalStudents(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.studentCount ?? 0), 0) ?? 0;
  }

  get totalEmployee(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.employeeCount ?? 0), 0) ?? 0;
  }

  get totalSubStaff(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.subStaffCount ?? 0), 0) ?? 0;
  }

  get totalVisitors(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.visitorsCount ?? 0), 0) ?? 0;
  }

  //end Supply building //

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  MenuCard(): void {
    const fromInventory = this.getScenarioBasedMenuItemsListFromInventory(this.inventroyData);
    const rawList = fromInventory.length > 0 ? fromInventory : this.scenarioBasedMenuItemsList;

    this.dialog.open(DoMenuComponent, {
      width: '30%',
      height: '100%',
      data: {
        scenarioBasedMenuItemsList: rawList,
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: false,
      hasBackdrop: true,
    });
  }

}
